import React from 'react';
import './styles.css'; // Import loader styles

const Loader = ({ loading }) => {
  return (
    <>
      {loading && (
        <div className="overlay">
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        </div>
      )}
    </>
  );
};

export default Loader;
